import { createSlice } from '@reduxjs/toolkit';

const initialState: BreadcrumbsState = {
    additionalParams: {}
};

const breadcrumbsSlice = createSlice({
    name: 'breadcrumbs',
    initialState,
    reducers: {
        addAdditionalBreadcrumbParams(state, action) {
            state.additionalParams[action.payload.pathname] = action.payload.params;
        }
    }
});

export const { addAdditionalBreadcrumbParams } = breadcrumbsSlice.actions;
export default breadcrumbsSlice.reducer;
